import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2bda3b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative flex flex-col justify-center h-full w-full text-white bg-custom-black p-4" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "relative flex justify-center h-full w-full text-white",
  id: "bg-custom"
}
const _hoisted_4 = { class: "flex flex-col space-y-4 backdrop-blur-3xl p-8 w-full h-full flex items-center overflow-x-auto" }
const _hoisted_5 = {
  key: 0,
  class: "z-50 fixed bottom-4 right-4 left-4 h-[10vh] grid grid-cols-4 content-end md:w-1/4 md:left-auto md:right-1 md:bottom-5"
}
const _hoisted_6 = {
  key: 1,
  class: "col-span-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white text-3xl z-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stopwatch" })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 3,
  class: "col-span-1"
}
const _hoisted_10 = {
  key: 1,
  class: "fixed -bottom-3 right-8 h-[10vh]"
}
const _hoisted_11 = { class: "flex flex-col space-y-4 h-full overflow-y-auto" }
const _hoisted_12 = { class: "flex flex-col-reverse w-full" }
const _hoisted_13 = { class: "flex flex-col space-y-4" }

import { computed, ComputedRef, Ref, ref, watch } from "vue";
import Timer from "@/Interfaces/Timer";
import { GameStates } from "@/Interfaces/GameStates";
import GameMenu from "@/components/Game/GameMenu.vue";
import GameInterface from "@/components/Game/GameInterface.vue";
import GameFinished from "@/components/Game/GameFinished.vue";
import TimerMenu from "@/components/Menu/TimerMenu.vue";
import MenuWithSmallMenus from "@/components/Menu/MenuWithSmallMenus.vue";
import ActionHelperModal from "@/components/Menu/ActionHelperModal.vue";
import ModalContainer from "@/components/Modals/ModalContainer.vue";
import PrimaryLabel from "@/components/Form/Common/PrimaryLabel.vue";
import ModalText from "@/components/Texts/ModalText.vue";
import TimerModalElements from "@/components/Timers/TimerModalElements.vue";
import { useDialogsStore } from "@/Store/useDialogsStore";
import BottomSheet from "@/components/Modals/BottomSheet.vue";
import { useGameStore } from "@/Store/useGameStore";
import Category from "@/Interfaces/Category";
import { Action } from "@/Interfaces/Action";
import PacManLoading from "@/components/Menu/PacManLoading.vue";
import BigTitle from "@/components/Title/BigTitle.vue";
import TestForm from "@/components/Form/Common/TestForm.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'GameView',
  setup(__props) {

const gameStore = useGameStore();

// Get all necessary reactive stuff from gameStore
const allCategories: ComputedRef<Category[]> = computed(() => {
  return gameStore.allCategories;
});

const allActions: ComputedRef<Action[]> = computed(() => {
  return gameStore.allActions;
});

const indexAction: ComputedRef<number> = computed(() => {
  return gameStore.indexAction;
});

const inGame: ComputedRef<number> = computed(() => {
  return gameStore.inGame;
});

const timers: ComputedRef<Timer[]> = computed(() => {
  return gameStore.timers;
});

const gameActions: ComputedRef<Action[]> = computed(() => {
  return gameStore.gameActions;
});

// Get data from backend
gameStore.getAllCategoriesAndActions();
/*
setTimeout(() => {
  gameStore.getAllCategoriesAndActions();
}, 50000);*/

// Manage dialogs
const dialogsStore = useDialogsStore();
const timersDialog = dialogsStore.createNewDialog();
const modalTimerFinished = dialogsStore.createNewDialog();
const timerFinishedSound = new Audio("/sounds/notifications.mp3");

// Manage border color
const gradientStyle = computed(() => {
  const color = ref("#4338ca");
  const color2 = ref("#9333ea");
  if (gameActions.value.length > 0 && inGame.value === GameStates.Started) {
    color.value = gameActions.value[indexAction.value].category.color;
    color2.value = gameActions.value[indexAction.value].category.color2;
  }
  return `linear-gradient(to right, ${color2.value}, ${color.value}) 1`;
});

// Manage timer
const timerExist: Ref<boolean> = computed(() => {
  return (
    gameStore.timers.find(
      (timer: Timer) => timer.action_id === indexAction.value
    ) !== undefined
  );
});

watch(
  () => gameStore.timerAlert,
  () => {
    dialogsStore.openModal(modalTimerFinished);
    timerFinishedSound.play();
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (allActions.value.length === 0 || allCategories.value.length === 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "border h-screen border-8 box-border",
        style: _normalizeStyle({ borderImage: gradientStyle.value })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(BigTitle, {
            title: "Chargement des données ...",
            class: "text-white text-left mx-4"
          }),
          _createVNode(PacManLoading, {
            class: "w-full",
            style: { 'margin-left': '60px' }
          })
        ])
      ], 4))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "border h-screen border-8 box-border",
          style: _normalizeStyle({ borderImage: gradientStyle.value })
        }, [
          _createElementVNode("div", _hoisted_3, [
            (inGame.value === _unref(GameStates).Started)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "absolute w-1/2 h-full left-0 z-10 bg-transparent",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(gameStore).lastAction()))
                }))
              : _createCommentVNode("", true),
            (inGame.value === _unref(GameStates).Started)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "absolute w-1/2 h-full right-0 z-10 bg-transparent",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(gameStore).nextAction()))
                }))
              : _createCommentVNode("", true),
            (inGame.value === _unref(GameStates).Finished)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "absolute w-full h-full right-0 z-10 bg-transparent",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(gameStore).restartGame()))
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              (inGame.value === _unref(GameStates).NotStarted)
                ? (_openBlock(), _createBlock(GameMenu, {
                    key: 0,
                    class: "flex flex-col space-y-4"
                  }))
                : (inGame.value === _unref(GameStates).Started)
                  ? (_openBlock(), _createBlock(GameInterface, { key: 1 }))
                  : (inGame.value === _unref(GameStates).Finished)
                    ? (_openBlock(), _createBlock(GameFinished, { key: 2 }))
                    : _createCommentVNode("", true)
            ])
          ])
        ], 4),
        (inGame.value === _unref(GameStates).Started)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (inGame.value === _unref(GameStates).Started && timerExist.value)
                ? (_openBlock(), _createBlock(TimerMenu, {
                    key: 0,
                    class: "col-span-2"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_6)),
              (inGame.value === _unref(GameStates).Started)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "mx-auto col-span-1 w-16 h-16 rounded-full flex justify-center items-center cursor-pointer transition-transform duration-1000 ease-in-out transform bg-gradient-to-b from-gray-900 to-gray-800",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(dialogsStore).openModal(_unref(timersDialog))))
                  }, _hoisted_8))
                : (_openBlock(), _createElementBlock("div", _hoisted_9)),
              _createVNode(MenuWithSmallMenus, { class: "col-span-1" })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(MenuWithSmallMenus, { class: "col-span-1" })
            ])),
        (
        inGame.value === _unref(GameStates).Started &&
        indexAction.value >= 1 &&
        gameActions.value[indexAction.value].help
      )
          ? (_openBlock(), _createBlock(ActionHelperModal, { key: 2 }))
          : _createCommentVNode("", true),
        _createVNode(BottomSheet, {
          "dialog-id": _unref(timersDialog),
          "out-side-closable": true,
          "all-draggable": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(PrimaryLabel, {
                text: "Timers :",
                class: "mb-2"
              }),
              (timers.value.length > 0)
                ? (_openBlock(), _createBlock(ModalText, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Appuyez sur le timer de votre choix afin de voir l'action liée. ")
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(ModalText, { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Pas de timer en cours. ")
                    ]),
                    _: 1
                  })),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timers.value, (timer, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(TimerModalElements, {
                      class: "mb-4",
                      timer: timer,
                      index: index
                    }, null, 8, ["timer", "index"])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["dialog-id"]),
        _createVNode(ModalContainer, {
          "dialog-id": _unref(modalTimerFinished),
          "out-side-closable": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(PrimaryLabel, {
                text: "Temps écoulé !",
                class: "mb-2"
              }),
              _createVNode(ModalText, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(gameActions.value[_unref(gameStore).timerAlert].description), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["dialog-id"])
      ]))
}
}

})